import TextModal from './TextModal'

export default TextModal
